import { defineComponent as _defineComponent } from 'vue'
import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';
import { getCurrentInstance, inject, ref } from 'vue';
import AuthService from '@/account/auth.service';
import AlertService from '@/shared/alert/alert.service';
import { AxiosError } from 'axios';
import SetupService from '@/pages/setup/setup.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'navBarLayout',
  setup(__props) {

const that = getCurrentInstance().proxy;

const isLoading = ref(true);

const authService = inject<() => AuthService>('authService');
const alertService = inject<() => AlertService>('alertService');
const setupService = inject<() => SetupService>('setupService');

const mandantId = ref(-1);
const isAdmin = ref(false);

const init = async () => {
  try {
    isAdmin.value = await authService().isAdmin();
    mandantId.value = await authService().getCurrentMandantId();
  } catch (error) {
    if (error instanceof AxiosError && error.code == 'ERR_NETWORK') {
      alertService().showError(
        that,
        'Der Server ist nicht erreichbar. Bitte versuchen Sie es später erneut.'
      );
    } else {
      console.error('Error loading page', error);
      alertService().showError(that, 'Fehler beim Laden der Seite');
    }
    mandantId.value = -1;
  } finally {
    isLoading.value = false;
  }
};
init();

/**
 *  check if setup needed
 */
const checkSetup = async () => {
  try {
    await setupService().checkSetup();
    console.log('checkSetup done');
  } catch (e) {
    console.error(e);
    let msg = 'Setup fehlgeschlagen';
    if (e.response?.data?.detail) {
      msg = e.response.data.detail;
    }
    alertService().showError(that, msg);
  }
};
checkSetup();

return { __sfc: true,that, isLoading, authService, alertService, setupService, mandantId, isAdmin, init, checkSetup, JhiFooter, JhiNavbar }
}

})